import { Box, ModBox, RadioButtonGroup, SpacerNew, TextNew } from '@jfs/ui-new'
import React, { useCallback, useEffect, useState } from 'react'
import SearchBar from '../../../../../components/SelectAllAndSearchComponent/SearchBar'
import { styles } from './styles'

const placeholderColor = '#bfbfbf'

const getPlaceholderValue = (rbTitles: string[], value: string) => {
  if (value === rbTitles[0]) {
    return 'Enter Parent ID'
  } else if (value === rbTitles[1]) {
    return 'Enter Parent Name'
  }
}

interface SearchParentEntityInterface {
  showRadioButtons: boolean
  title: string
  placeholder: string
  hideComponent: boolean
  setFieldValue?: (fieldName: string, value: any) => void
  fieldName?: string
  // allValues?: any
  searchTitle?: string
  radioBtnTitles?: string[]
  getSelectedData?: (selectedData: string) => void
  showSearch?: boolean
  onSearchPress?: (searchStr: string) => void
  selectedRadioBtn?: string
  isSearchLoading?: boolean
  onClearPressed?: () => void
  searchValue?: string
  clearSearchedText?: boolean
  value?: string
}

const SearchParentEntity = React.memo(
  ({
    showRadioButtons = true,
    title,
    placeholder,
    hideComponent = false,
    value = '',
    fieldName,
    searchTitle,
    radioBtnTitles,
    getSelectedData,
    showSearch = false,
    onSearchPress,
    selectedRadioBtn,
    isSearchLoading,
    onClearPressed,
    searchValue = '',
    clearSearchedText = false,
  }: SearchParentEntityInterface) => {
    const [searchString, updateSearchString] = useState(value)

    const isMidField = fieldName === 'searchByMasOrMid'

    const onSearchTextChange = useCallback(
      (text: string) => {
        updateSearchString(text)
        if (text === '') {
          onClearPressed && onClearPressed()
        }
      },
      [onClearPressed],
    )

    const onClearPress = useCallback(() => {
      updateSearchString('')
      onClearPressed && onClearPressed()
    }, [onClearPressed])

    useEffect(() => {
      if (clearSearchedText) {
        onClearPress()
      }
    }, [clearSearchedText, onClearPress])

    const onSearchPressHandle = () => {
      onSearchPress(searchString)
    }

    if (hideComponent || isMidField || fieldName === 'searchByMasOrMid') {
      return null
    }

    const onRbgChange = (checkedStr: string) => {
      getSelectedData && getSelectedData(checkedStr)
      console.log('onRbgChange selectedName', checkedStr)
    }
    console.log('===> searchValue, searchString: ', searchValue, searchString)
    return (
      <Box {...styles.mainView}>
        <TextNew title={title} {...styles.titleText} />
        <ModBox show={showRadioButtons}>
          <RadioButtonGroup
            data={radioBtnTitles}
            textSize={12}
            size={14}
            textPadding={0}
            minItemHeight={36}
            textColor={'PRIMARY_GREY'}
            horizontalGap={20}
            color={'BLUE_SHADE_PRIMARY'}
            direction={'horizontal'}
            onChange={onRbgChange}
            value={selectedRadioBtn}
          />
        </ModBox>
        <SpacerNew size={8} direction={'vertical'} />
        <ModBox show={showSearch} width={328}>
          <TextNew title={searchTitle} {...styles.titleText} />
          <SpacerNew size={8} direction={'vertical'} />
          <SearchBar
            onChange={onSearchTextChange}
            value={searchString?.length > 0 ? searchString : searchValue}
            hide={false}
            fontSize={12}
            placeholder={placeholder.length > 0 ? placeholder : getPlaceholderValue(radioBtnTitles, selectedRadioBtn)}
            hideLeftIcons={true}
            placeholderTextColor={placeholderColor}
            transparentBg={true}
            rightCompColor={'BLUE_SHADE_PRIMARY'}
            onClearPress={onClearPress}
            showRightIcon={true}
            fullWidth={true}
            onSearchPress={onSearchPressHandle}
            isLoading={isSearchLoading}
          />
        </ModBox>
      </Box>
    )
  },
)

export { SearchParentEntity }
